<template>
    <div v-if="!loading">
        <div v-if="hasFreeMessages" class="kmn-usage-progess">
            <strong> Text message usage </strong>
            <div class="free-messages">
                <ds-icon name="message" class="message-icon" /> <span> Included text messages (per billing cycle) </span>
            </div>

            <ds-progress-bar
                class="progress-bar"
                :progress="messageCount"
                :max="textLimit"
                :label=" `${messageCount}/${textLimit} text messages used`"
                hide-label-value
            />
        </div>

        <div v-if="!hasFreeMessages">
            <span> Text message usage </span>
            <div class="usage-spent-container">
                <div class="usage-spent">
                    Total spent this billing cycle
                </div>

                <ds-popover position="right">
                    <template #reference>
                        <ds-icon class="info-icon" name="info-circle" />
                    </template>

                    <template #default>
                        <div class="usage-info-tooltip-content">
                            This is based on the ${{ PRICE_PER_MESSAGE }} fee per text message opt in. It’s charged in addition to your Keap account bill.
                        </div>
                    </template>
                </ds-popover>
            </div>

            <div>
                <div class="total-spent">
                    ${{ totalSpent }}
                </div>
                <div>
                    <div class="message-counts">
                        Total included text messages sent: {{ textLimit }}
                    </div>
                    <div class="message-counts">
                        Total additional text messages sent: {{ paidMessages }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

const PRICE_PER_MESSAGE = 0.015;

export default {
    name: 'TextMessageUsage',

    data() {
        return {
            textLimit: 250,
            messageCount: 0,
            loading: false,
            PRICE_PER_MESSAGE,
        };
    },

    mounted() {
        try {
            this.load();
        } catch {
            this.closeIframe();
        }
    },

    computed: {
        totalSpent() {
            return (this.paidMessages * PRICE_PER_MESSAGE).toFixed(3);
        },

        paidMessages() {
            return (this.messageCount <= this.textLimit) ? 0 : (this.messageCount - this.textLimit);
        },

        hasFreeMessages() {
            return this.messageCount < this.textLimit;
        },
    },

    methods: {

        async load() {
            try {
                this.loading = true;
                const { data } = await axios.get('/app/automatedSmsFunnel/getSMSUsageBillingCycle');

                this.messageCount = data.messageCount;
                this.textLimit = data.limit;
                this.loading = false;
            } catch (error) {
                this.closeIframe();
            }
        },

        closeIframe() {
            const modalIframe = window.parent.document.getElementById('textMessageUsage');

            modalIframe.parentNode.removeChild(modalIframe);
        },
    },
};
</script>

<style lang="scss" scoped>
    .info-icon {
        --icon-size: #{$icon-size-small};
        height: 0.5rem;
        width: 0.5rem;
        margin: 0.66rem 0 0 $spacing-050;
    }

    .usage-info-tooltip-content {
        padding: $spacing-200;
    }

    .kmn-usage-progess {
        width: px-to-rem(350px);
    }

    .usage-spent {
        font-size: $font-size-sm;
        font-weight: bold;
        margin-top: $spacing-100;
    }

    .message-counts {
        margin-top: $spacing-050;
    }

    .usage-spent-container {
        display: flex;
        align-items: center;
    }

    .total-spent {
        font-size: $font-size-md;
        font-family: "Sul Mono";
        margin-bottom: $spacing-100;
    }

    .free-messages {
        display: flex;
        align-items: center;
        margin: $spacing-100 0;
    }

    .message-icon {
        margin-right: $spacing-100;
    }

</style>
